/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import s from "./Heading.module.css";
import { FC, ReactNode } from "react";

type Props = {
  children: ReactNode
  as: keyof JSX.IntrinsicElements
  className?: string 
  isBold?: boolean
}

const HEADINGS = ["h1", "h2", "h3", "h4", "h5", "h6"];
const Heading: FC<Props> = ({ children, as, className, isBold = true }) => {
  let Tag = as;
  if (!HEADINGS.includes(Tag)) Tag = "h1";
  return (
    <Tag className={cn(className, s[as], isBold ? "font-bold" : "font-normal", "break-all")}>
      {children}
    </Tag>
  );
};

export default Heading;
